import PropTypes from 'prop-types'
import { isNil } from 'ramda'

class NavMemberServicesRequest {
  constructor(init) {
    if (isNil(init)) return undefined

    this._member_name = init.nav_member_services_request_member_name
    this._date_of_birth = init.nav_member_services_request_date_of_birth
    this._member_need = init.nav_member_services_request_member_need
    this._contact_method_type =
      init.nav_member_services_request_contact_method_type
    this._contact_method_value =
      init.nav_member_services_request_contact_method_value

    this._user_email = init.user_email
    this._user_name = init.user_name
    this._user_phone_number = init.user_phone_number
    this._organization_name = init.organization_name
    this._users_job_title = init.users_job_title
  }

  static shape = {
    member_name: PropTypes.string.isRequired,
    date_of_birth: PropTypes.string.isRequired,
    member_need: PropTypes.string.isRequired,
    contact_method_type: PropTypes.string.isRequired,
    contact_method_value: PropTypes.string.isRequired,

    user_email: PropTypes.string,
    user_name: PropTypes.string,
    user_phone_number: PropTypes.string,
    organization_name: PropTypes.string,
    users_job_title: PropTypes.string
  }

  get member_name() {
    return this._member_name
  }

  get date_of_birth() {
    return this._date_of_birth
  }

  get member_need() {
    return this._member_need
  }

  get contact_method_type() {
    return this._contact_method_type
  }

  get contact_method_value() {
    return this._contact_method_value
  }

  get user_email() {
    return this._user_email
  }

  get user_name() {
    return this._user_name
  }

  get user_phone_number() {
    return this._user_phone_number
  }

  get organization_name() {
    return this._organization_name
  }

  get users_job_title() {
    return this._users_job_title
  }
}

export default NavMemberServicesRequest
